import * as React from 'react';

class SuccessCheckMarkSvg extends React.Component<Svg.IProps, Svg.IState> {
  static defaultProps: Svg.IProps = { className: '' };

  render() {
    const { className, ...rest } = this.props;

    return (
      <svg
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`svg-icon success-check-mark-svg ${className || 'm-3'}`}
        {...rest}
      >
        <circle cx="10.5" cy="10.5" r="9.5" stroke="#B9B708" strokeWidth="2" />
        <rect x="6.09717" y="11.5608" width="1.62976" height="4.30429" transform="rotate(-52.78 6.09717 11.5608)" fill="#B9B708" />
        <rect x="13.0537" y="6.77417" width="1.64306" height="7.97164" transform="rotate(37.0778 13.0537 6.77417)" fill="#B9B708" />
      </svg>
    );
  }
}

export default SuccessCheckMarkSvg;
